/**
 * «Скрыть на этом устройстве» для звонка, который идёт на другом.
 *
 * Панель фазы `elsewhere` намеренно остаётся после переноса разговора: без неё вернуть звонок
 * обратно было бы нечем. Но убрать её с глаз человеку тоже нечем — красная трубка это `hangup`,
 * а он завершает разговор у обоих (мутация даже не принимает sessionId). Отсюда третий, безобидный
 * выход: клиент помнит, что эту панель здесь уже закрыли, и больше её не поднимает.
 *
 * Хранится в `sessionStorage` рядом с [[clientSession]] и по тем же причинам: перезагрузка
 * страницы не должна возвращать закрытую панель, а соседняя вкладка — это другой клиент, и
 * решение одной вкладки её не касается. Ключ один: активный звонок у человека тоже один.
 */
const STORAGE_KEY = 'tp-call-dismissed';

let cached: string | null = null;

/** Больше не показывать здесь панель переноса для этого звонка. */
export const dismissCallHere = (callId: string): void => {
  cached = callId;
  try {
    sessionStorage.setItem(STORAGE_KEY, callId);
  } catch {
    // Приватный режим: решение живёт до перезагрузки. Панель вернётся — не страшно.
  }
};

/** Закрывали ли уже панель переноса именно этого звонка на этом клиенте. */
export const isCallDismissedHere = (callId: string): boolean => {
  // Память процесса спрашиваем первой, и это не оптимизация: Safari в приватном режиме роняет
  // `setItem`, но исправно отвечает на `getItem`. Спроси мы сперва хранилище — оно честно вернуло
  // бы «ничего не закрывали», и панель вернулась бы через секунду после того, как её убрали.
  if (cached === callId) {
    return true;
  }
  try {
    return sessionStorage.getItem(STORAGE_KEY) === callId;
  } catch {
    return false;
  }
};
